/* Shared by the mobile chip scroller (below the hero) and the desktop results toolbar
   (above the month list) - the "Filters" opener pill, removable active-filter chips, the
   List/Flyers/Calendar/Map segmented control, and the sort select. */

.mobileScroller {
  display: flex;
  gap: 8px;
  padding: 12px 16px;
  overflow-x: auto;
  white-space: nowrap;
  border-bottom: 1px solid var(--border-1);
}

.filtersOpener {
  flex-shrink: 0;
  height: 40px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 14px;
  border-radius: var(--r-pill);
  background: var(--bg-dark);
  color: var(--text-on-dark);
  border: 0;
  font-size: 14px;
  font-weight: 600;
}
.filtersOpenerBadge {
  background: var(--accent);
  border-radius: var(--r-pill);
  padding: 0 7px;
  font-size: 12px;
}

.removableChip {
  flex-shrink: 0;
  height: 34px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 10px 0 12px;
  border-radius: var(--r-pill);
  border: 1.5px solid var(--accent);
  background: var(--bg-accent-tint-2);
  color: var(--accent-text-hover);
  font-size: 14px;
  font-weight: 600;
}

.desktopToolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
.resultsGroup {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.resultsCount {
  font-weight: 700;
  font-size: 17px;
  margin-right: 6px;
}
.controlsGroup {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}
.sortLabel {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: var(--text-muted);
}
.sortSelect {
  height: 40px;
  padding: 0 8px;
  border-radius: var(--r-8);
  border: 1px solid var(--border-4);
  background: var(--bg-panel);
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}

.viewToggle {
  display: flex;
  padding: 3px;
  border-radius: var(--r-10);
  background: var(--bg-tint);
}
.mobileViewToggle {
  display: flex;
  padding: 3px;
  border-radius: var(--r-10);
  background: #e8e4dc;
}
.viewButton {
  height: 36px;
  padding: 0 14px;
  border-radius: var(--r-8);
  border: 0;
  background: transparent;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-muted);
}
.viewButtonActive {
  background: var(--bg-panel);
  font-weight: 700;
  color: var(--text-primary);
  box-shadow: 0 1px 3px rgba(21, 23, 26, 0.12);
}
.viewButtonDisabled {
  color: var(--border-4);
  cursor: default;
}

.postEventBox {
  margin: 8px 0 0;
  padding: 16px;
  border-radius: var(--r-14);
  border: 1px dashed var(--border-dashed);
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.postEventTitle {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 20px;
  text-transform: uppercase;
}
.postEventBody {
  font-size: 14px;
  line-height: 1.45;
  color: var(--text-secondary);
}
.postEventLink {
  font-weight: 700;
  font-size: 15px;
  min-height: 44px;
  display: flex;
  align-items: center;
}
